import { getTaskGroup } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';

export const useGetTaskGroup = (taskGroupId: string) => {
  return useQuery(['task-group', taskGroupId], () => getTaskGroup(taskGroupId));
};
